import React from 'react';
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Radio,
  Slider,
  Tooltip,
  message, Switch
} from 'antd';
import classnames from 'classnames';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { connect } from 'react-redux';
import moment from "moment-timezone";

import {
  updateFollowUp30Request,
  lockFollowUp30Request,
  unlockFollowUp30Request,
} from "../../api/requests";
import {
  getFollowUp30dCreatePermissionBySite,
  getFollowUp30dUpdatePermissionBySite,
  getFollowUp30dLockPermissionBySite,
  getFollowUp30dUnlockPermissionBySite, getUserTimezone, getUserShortTimezone
} from "../../reducers/user/selectors";

import classes from './FollowUp30DayForm.css';
import {logout} from "../../reducers/user/actions";
import {Link} from "react-router-dom";
import { withNamespaces } from 'react-i18next';

const routes = require('../../routes.json');

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class FollowUp30DayForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showFollowupForm: true,
      showContactInformation: false,
      showAdditionalContactInformation: false,
      locked: false,
      locked_date: null,
    };
  }

  componentDidMount() {
    this.setState({
      locked: get(this.props, 'locked'),
      locked_date: get(this.props, 'locked_date')
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { followUp30dUpdatePermission } = this.props;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err && followUp30dUpdatePermission) {
        this.setState({ isLoading: true });

        try {
          const followUp = cloneDeep(values);
          if (values.scheduled_date) { followUp.scheduled_date = cloneDeep(values.scheduled_date).utc().format('YYYY-MM-DDTHH:mm:ss'); }

          await updateFollowUp30Request(this.props.subjectID , followUp);
          // this.props.onSubmit(this.props.subjectID);

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          // this.props.onSubmit(this.props.subjectID);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  collapseSection = sectionName => () => {
    this.setState(state =>({ [sectionName]: !state[sectionName] }));
  };

  onSwitchLock = async() => {
    try {
      if (this.state.locked) {
        await unlockFollowUp30Request(this.props.subjectID);
        this.setState({ locked: false, locked_date: null });
      } else {
        await lockFollowUp30Request(this.props.subjectID);
        this.setState({ locked: true, locked_date: new Date() });
      }
      message.success(this.props.i18n.t('Saved'));
    } catch(e) {
      message.error(get(e, 'response.data.error', 'Error'));
    }
  };

  onDone = () => {
    this.props.onSubjectClear();
    this.props.history.push(routes.admin.followUp30Day);
  };

  render() {
    const { isLoading, requestResult, showFollowupForm, showContactInformation, showAdditionalContactInformation, locked, locked_date } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { id, allow_to_edit, followUp30dUpdatePermission, followUp30dLockPermission, followUp30dUnlockPermission } = this.props;

    const isEditable = ((followUp30dUpdatePermission && !locked) || (followUp30dUpdatePermission && allow_to_edit));
    const isObtainedBy = getFieldValue('is_obtained_by');
    const providedBy = getFieldValue('provided_by');

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>

          <h4 className={classnames('headline-default', classes.toggleHeadline)} onClick={this.collapseSection('showContactInformation')}>
            <Tooltip title={showContactInformation ? 'collapse' : 'show'}>
              <Icon type="arrow-up" className={classes.collapseIcon} style={{ fontSize: '20px', transform: `rotate(${showContactInformation ? '0' : '180deg'})`  }} /> &nbsp;
            </Tooltip>

            <span className={classes.headlineText}>{this.props.i18n.t('Contact Information')}</span>
          </h4>

          {showContactInformation && (<div>
            <p><b>{this.props.i18n.t('Name')}:</b> {get(this.props, 'subject.profile.first_name')} {get(this.props, 'subject.profile.last_name')}</p>
            <p><b>{this.props.i18n.t('Phone number')}:</b> ({get(this.props, 'subject.profile.phone_number_type_1')}) {get(this.props, 'subject.profile.phone_number_1')}</p>
            { get(this.props, 'subject.profile.phone_number_2') && <p><b>{this.props.i18n.t('Phone number 2')}:</b> ({get(this.props, 'subject.profile.phone_number_type_2')}) {get(this.props, 'subject.profile.phone_number_2')}</p>}
            <p><b>{this.props.i18n.t('Email')}:</b> {get(this.props, 'subject.profile.email')}</p>
            <p><b>{this.props.i18n.t('Consent given')}:</b> {get(this.props, 'subject.has_consent_given', get(this.props, 'subject.profile.is_consent_given' || '')) ? this.props.i18n.t('Yes') : this.props.i18n.t('No')}</p>
            {/* <p><b>Consent type:</b> {get(this.props, 'consent.type') ? <a href={get(this.props, 'consent.link')} target='_blank'>{get(this.props, 'consent.type')}</a> : <span>None. Please provide <Link to='/consent'>consent here</Link></span>}</p> */}
            <p><b>{this.props.i18n.t('Comments')}:</b> {get(this.props, 'subject.profile.comments')}</p>
          </div>)}

          <h4 className={classnames('headline-default', classes.toggleHeadline)} onClick={this.collapseSection('showAdditionalContactInformation')}>
            <Tooltip title={showAdditionalContactInformation ? 'collapse' : 'show'}>
              <Icon type="arrow-up" className={classes.collapseIcon} style={{ fontSize: '20px', transform: `rotate(${showAdditionalContactInformation ? '0' : '180deg'})`  }} /> &nbsp;
            </Tooltip>

            <span className={classes.headlineText}>{this.props.i18n.t('Additional Contact Information')}</span>
          </h4>

          {showAdditionalContactInformation && (<div>
            <h5 className="headline-default">{this.props.i18n.t('Other contacts')}</h5>

            <Row gutter={12}>
              <Col md={8}>
                <p><b>{this.props.i18n.t('Contact 1')}</b></p>
                <p><b>{this.props.i18n.t('Name')}:</b> {get(this.props, 'subject.profile.contact_1_first_name')} {get(this.props, 'subject.profile.contact_1_last_name')}</p>
                <p><b>{this.props.i18n.t('Relationship')}:</b> {get(this.props, 'subject.profile.contact_1_relationship_type')}</p>
                <p><b>{this.props.i18n.t('Phone number')}:</b> ({get(this.props, 'subject.profile.contact_1_phone_number_type')}) {get(this.props, 'subject.profile.contact_1_phone_number')}</p>
              </Col>

              {get(this.props, 'subject.profile.contact_2_first_name') && (<Col md={8}>
                <p><b>{this.props.i18n.t('Contact 2')}</b></p>
                <p><b>{this.props.i18n.t('Name')}:</b> {get(this.props, 'subject.profile.contact_2_first_name')} {get(this.props, 'subject.profile.contact_2_last_name')}</p>
                <p><b>{this.props.i18n.t('Relationship')}:</b> {get(this.props, 'subject.profile.contact_2_relationship_type')}</p>
                <p><b>{this.props.i18n.t('Phone number')}:</b> ({get(this.props, 'subject.profile.contact_2_phone_number_type')}) {get(this.props, 'subject.profile.contact_2_phone_number')}</p>
              </Col>)}

              <Col md={8}>
                <p><b>{this.props.i18n.t('Family Doctor')}</b></p>
                <p><b>{this.props.i18n.t('Name')}:</b> {get(this.props, 'subject.profile.family_doctor_first_name')} {get(this.props, 'subject.profile.family_doctor_last_name')}</p>
                <p><b>{this.props.i18n.t('Clinic name')}:</b> {get(this.props, 'subject.profile.family_doctor_clinic_name')}</p>
                <p><b>{this.props.i18n.t('Phone number')}:</b> ({get(this.props, 'subject.profile.family_doctor_phone_number_type')}) {get(this.props, 'subject.profile.family_doctor_phone_number')}</p>
              </Col>
            </Row>
          </div>)}


          <h4 className={classnames('headline-default', classes.toggleHeadline)} onClick={this.collapseSection('showFollowupForm')}>
            <Tooltip title={showFollowupForm ? 'collapse' : 'show'}>
              <Icon type="arrow-up" className={classes.collapseIcon} style={{ fontSize: '20px', transform: `rotate(${showFollowupForm ? '0' : '180deg'})`  }} /> &nbsp;
            </Tooltip>

            <span className={classes.headlineText}>{this.props.subjectID}</span>
            &nbsp;<Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} />
            &nbsp;{id && <Badge count={locked ? `Locked by ${get(this.props, 'locked_by_username')}` : 'Unlocked'} style={{ backgroundColor: locked ? '#f00' : '#49c850', textTransform: 'none' }} />}
            &nbsp;
            {locked_date && <Badge count={`${this.props.i18n.t('Locked at')} ${moment.utc(locked_date).tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').format('YYYY-MM-DD HH:mm')} ${this.props.userShortTimezone || get(this.props, 'site.short_tz') || 'UTC'}`}   style={{ backgroundColor: '#f00', textTransform: 'none' }} />}
          </h4>


          {showFollowupForm && (<div>
            <p>{this.props.i18n.t('Scheduled visit(s)')}</p>

            <Row gutter={12}>
              <Col lg={6}>
                <label>
                  <b>{this.props.i18n.t('Date*')}</b>
                  <Form.Item>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {getFieldDecorator('scheduled_date', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: get(this.props, 'scheduled_date') ? moment.utc(this.props.scheduled_date).tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC') : null
                      })(
                        <DatePicker
                          disabled={!isEditable}
                          placeholder="yyyy-mm-dd"
                          format='YYYY/MM/DD HH:mm'
                          showTime={{ format: 'HH:mm' }}
                        />,
                      )}

                      &nbsp;{this.props.userShortTimezone || get(this.props, 'site.short_tz') || 'UTC'}
                    </div>
                  </Form.Item>
                </label>
              </Col>
              <Col lg={6}>
                <p style={{ marginTop: '30px' }}>
                  <b>{this.props.i18n.t('Site')}: </b> {get(this.props, 'site.name')}
                </p>
              </Col>
            </Row>

            <h5 className='headline-default'>{this.props.i18n.t('1. Method information is obtained')}:</h5>
            <Row gutter={12}>
              <Col lg={6}>

                <label>
                  <b>{this.props.i18n.t('Method*')}:</b>
                  <Form.Item>
                    {getFieldDecorator('is_obtained_by', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'is_obtained_by', '')
                    })(
                      <Select disabled={!isEditable} placeholder='Select'>
                        <Option value="by_phone">{this.props.i18n.t('By phone')}</Option>
                        <Option value="in_person">{this.props.i18n.t('In-person')}</Option>
                        <Option value="email">{this.props.i18n.t('Email')}</Option>
                        <Option value="by_mail">{this.props.i18n.t('By mail')}</Option>
                        <Option value="other">{this.props.i18n.t('Other')}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
              {isObtainedBy === 'other' && <Col lg={6}>
                <label>
                  <b>{this.props.i18n.t('Other*')}</b>
                  <Form.Item>
                    {getFieldDecorator('obtained_by_other', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'obtained_by_other')
                    })( <Input disabled={!isEditable} /> )}
                  </Form.Item>
                </label>
              </Col>}
            </Row>

            <h5 className='headline-default'>{this.props.i18n.t('2. Who is providing the following information?')}</h5>
            <Row gutter={12}>
              <Col lg={6}>

                <label>
                  <b>{this.props.i18n.t('Provided by*')}</b>
                  <Form.Item>
                    {getFieldDecorator('provided_by', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'provided_by', '')
                    })(
                      <Select disabled={!isEditable} placeholder='Select'>
                        <Option value="patient_self">{this.props.i18n.t('Patient/ Self')}</Option>
                        <Option value="surrogate">{this.props.i18n.t('Surrogate')}</Option>
                        <Option value="family_member">{this.props.i18n.t('Family Member')}</Option>
                        <Option value="care_home_nurse">{this.props.i18n.t('Care Home Nurse')}</Option>
                        <Option value="other">{this.props.i18n.t('Other')}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
              {providedBy === 'other' && <Col lg={6}>
                <label>
                  <b>{this.props.i18n.t('Other*')}</b>
                  <Form.Item>
                    {getFieldDecorator('provided_by_other', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'provided_by_other')
                    })( <Input disabled={!isEditable} /> )}
                  </Form.Item>
                </label>
              </Col>}
            </Row>

            <h5 className='headline-default'>{this.props.i18n.t('3. What is the status of the follow-up?')}</h5>
            <Row gutter={12}>
              <Col lg={12}>
                <label>
                  <Form.Item>
                    {getFieldDecorator('follow_up_status', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'follow_up_status', '').toString()
                    })(
                      <Radio.Group disabled={!isEditable}>
                        <Radio value="not_started">{this.props.i18n.t('Not started')}</Radio>
                        <Radio value="in_progress">{this.props.i18n.t('In progress')}</Radio>
                        <Radio value="completed">{this.props.i18n.t('Completed')}</Radio>
                        <Radio value="lost">{this.props.i18n.t('Lost in follow-up')}</Radio>
                        <Radio value="missed">{this.props.i18n.t('Missed')}</Radio>
                        <Radio value="consent_not_given">{this.props.i18n.t('Not required - consent not given')}</Radio>
                        <Radio value="patient_deceased">{this.props.i18n.t('Not required - patient deceased')}</Radio>
                      </Radio.Group>,
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col lg={12}>
                <label>
                  <b>{this.props.i18n.t('Comments/ Notes')}:</b>
                  <Form.Item>
                    {getFieldDecorator('event_comments', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'event_comments')
                    })(
                      <Input.TextArea disabled={!isEditable} rows={4}  />
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>


            {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

            <Form.Item className={classes.formActions}>
              {id && (<Button size="large" htmlType="button" onClick={this.onDone}>
                {this.props.i18n.t('Done')}
              </Button>)}

              &nbsp;

              {isEditable && <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>}
              &nbsp;&nbsp;
              <Tooltip placement="topLeft" title="Lock / Unlock the FollowUp">
                {this.props.i18n.t('Lock status')}: &nbsp;
                <Switch disabled={((!followUp30dUnlockPermission && locked) || (!followUp30dLockPermission && !locked))} checked={locked} onChange={this.onSwitchLock} />
              </Tooltip>
            </Form.Item>
            </div>)}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  followUp30dCreatePermission: getFollowUp30dCreatePermissionBySite(get(props, 'site.id'))(state),
  followUp30dUpdatePermission: getFollowUp30dUpdatePermissionBySite(get(props, 'site.id'))(state),
  followUp30dLockPermission: getFollowUp30dLockPermissionBySite(get(props, 'site.id'))(state),
  followUp30dUnlockPermission: getFollowUp30dUnlockPermissionBySite(get(props, 'site.id'))(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'followUp30day' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FollowUp30DayForm)));



// WEBPACK FOOTER //
// ./src/components/FollowUp30DayForm/FollowUp30DayForm.js